module.exports = __webpack_public_path__ + "img/bg-3.470059ef.jpg";